import dayjs, { Dayjs } from 'dayjs';
import { ValueOf } from '../../../types/common/utils';
import { DATE_FORMAT } from '../../../constants/service/common/dateConstants';

export const formatDate = (
  date?: string | Dayjs | null,
  format: ValueOf<typeof DATE_FORMAT> = DATE_FORMAT.FULL_DASH_FORMAT,
): string => {
  if (!date || !dayjs(date).isValid()) return '-';
  return dayjs(date).format(format);
};
